<template>
    <div class="row">
        <div class="col-12">
            <h1>{{$t('orders.header_main')}}</h1>
            <p>{{$t('orders.label_info')}}.</p>

            <transition name="slide-fade">
                <div v-if="!loadingLastOrder">
                    <div class="alert--info" v-if="lastOrder">
                        {{$t('form.order_salt.order_under_review_1')}}
                        {{lastOrder.created}}
                        {{$t('form.order_salt.order_under_review_2')}}
                        {{$t('form.order_salt.order_under_review_3')}}
                    </div>
                </div>
            </transition>

            <loader :loading="loading" :error="error" class="table__responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th><strong>{{$t('orders.header_id')}}</strong></th>
                        <th>{{$t('orders.header_date')}}</th>
                        <th>{{$t('orders.header_price')}}</th>
                        <th>{{$t('orders.header_type')}}</th>
                        <th>{{$t('orders.header_download')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="order in orders">
                        <td><strong>{{order.id}}</strong></td>
                        <td>{{formatDate(order.date)}}</td>
                        <td>{{$n(order.price, 'money')}}</td>
                        <td>{{$t('common.order_type.' + order.type)}}</td>
                        <td>
                            <a @click="openUrl(order.download_url)"  v-if="order.download_url" target="_blank">
                                <i class="mdi mdi-download"></i>
                                {{$t('orders.label_download')}}
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </loader>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import {FETCH_LAST_ORDER, FETCH_ORDERS, GET_LAST_ORDER, GET_ORDERS, FETCH_PDF} from '../store/modules/orders';
    import moment from 'moment';
    import Loader from '../components/general/Loader';

    @Component({
        components: {Loader}
    })
    export default class Orders extends Vue {
        loading = false;
        error = false;
        loadingLastOrder = false;
        // orders/api/orders/file
        // /uploads/orders/68986.pdf

        async openUrl(url){
            await this.$store.dispatch(FETCH_PDF, url);
        }

        created() {
            this.loadingLastOrder = true;
            this.loading = true;
            this.error = false;
            this.fetchLastOrder();
            this.fetchOrders();
        }

        get orders() {
            return this.$store.getters[GET_ORDERS];
        }

        formatDate(date) {
            return moment(date).calendar();
        }

        async fetchOrders(){
            try {
                await this.$store.dispatch(FETCH_ORDERS);
            } catch (e){
                this.error = this.$t('common.notify_fetch_failure');
                this.$notify.error(this.error);
            } finally {
                this.loading = false;
            }
        }

        async fetchLastOrder() {
            try {
                await this.$store.dispatch(FETCH_LAST_ORDER);
            } catch (e){
                //if the last order is not available, dont give error.
            } finally {
                this.loadingLastOrder = false;
            }
        }

        get lastOrder() {
            if (this.$store.getters[GET_LAST_ORDER].hasOwnProperty('completed') && this.$store.getters[GET_LAST_ORDER].hasOwnProperty('created')) {
                if (this.$store.getters[GET_LAST_ORDER].completed === false) {
                    return this.$store.getters[GET_LAST_ORDER];
                } else return false;
            } else {
                return false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Orders.vue